var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","outlined":"","small":""},on:{"click":_vm.submit}},[_vm._v("Pay By Check")])
}
var staticRenderFns = []

export { render, staticRenderFns }